module.exports = __webpack_public_path__ + "assets/6d6415578c61006f199378ec0215e24d.png";